import React, { useEffect, useState } from "react";
import { Container, Grid } from "@mui/material";
import HomeLayout from "layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import i18n from "i18next";

import { getNewsList } from "context/actions/news";
import { getLinkList } from "context/actions/link";
import { getSpecialAlert } from "context/actions/alert";
import { getView, insertView } from "context/actions/view";

import BestList from "components/BestList";
import NewsItem from "components/NewsItem";
import AlertPopUp from "components/AlertPopUp";
import Views from "components/Views";
import CoverNew from "components/CoverNew";
import Card from "components/Card";
import { ArrowRight } from "lucide-react";

const SectionLabel = ({ children }) => (
  <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#EFF6FF", borderRadius: 100, padding: "6px 16px", marginBottom: 12 }}>
    <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#0047AB" }} />
    <span style={{ fontSize: 13, fontWeight: 600, color: "#0047AB", textTransform: "uppercase", letterSpacing: "0.04em" }}>{children}</span>
  </div>
);

const HomePage = () => {
  const { t } = useTranslation();
  const [allNews, setAllNews] = useState([]);
  const [link, setLink] = useState([]);
  const [alert, setAlert] = useState(null);
  const [viewData, setView] = useState(null);

  useEffect(() => {
    const load = async () => {
      const [rNews, rLink, rAlert, , rView] = await Promise.all([
        getNewsList("", 1, 3, "", 1),
        getLinkList(),
        getSpecialAlert(),
        insertView(),
        getView(),
      ]);
      if (rNews.status === "success") setAllNews(rNews.data.list);
      if (rLink.status === "success") setLink(rLink.data);
      if (rAlert.status === "success") setAlert(rAlert.data);
      if (rView.status === "success") setView(rView.data);
    };
    load();
  }, []);

  return (
    <div>
      {/* Hero */}
      <CoverNew />

      {/* Card / Services */}
      <Card />

      {/* News Section */}
      <section style={{ background: "#fff", padding: "80px 0" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: 40 }}>
            <div>
              <SectionLabel>Мэдээ мэдээлэл</SectionLabel>
              <h2 style={{
                fontSize: "clamp(1.6rem, 2.5vw, 2.2rem)",
                fontWeight: 800, color: "#0A0F1E", margin: 0,
                fontFamily: "'Outfit', 'Inter', sans-serif",
              }}>
                {t("news") || "Сүүлийн мэдээнүүд"}
              </h2>
            </div>
            <Link href="/newsList/1" style={{ textDecoration: "none" }}>
              <button style={{
                display: "flex", alignItems: "center", gap: 6,
                background: "#EFF6FF", color: "#0047AB",
                border: "1px solid #BFDBFE",
                borderRadius: 10, padding: "9px 18px",
                fontSize: 13.5, fontWeight: 600, cursor: "pointer",
                transition: "all 0.2s",
              }}
                onMouseEnter={e => { e.currentTarget.style.background = "#0047AB"; e.currentTarget.style.color = "#fff"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "#EFF6FF"; e.currentTarget.style.color = "#0047AB"; }}
              >
                Бүгдийг үзэх <ArrowRight size={15} />
              </button>
            </Link>
          </div>

          <Grid container spacing={3} className="stagger">
            {allNews.map((item, ind) => (
              <Grid key={ind} item lg={4} md={4} sm={6} xs={12} className="animate-fade-up">
                <NewsItem
                  newsId={item.id}
                  imageUrl={item.imageUrl}
                  date={item.createdAtDay}
                  name={i18n.language === "en" ? item.nameEng : item.name}
                  description={i18n.language === "en" ? item.descriptionEng : item.description}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </section>

      {/* Partners */}
      <BestList linkData={link} />

      {/* Stats */}
      <Views viewValue={viewData} />

      {alert?.imageUrl && <AlertPopUp open={true} handleClose={() => setAlert(null)} alert={alert} />}
    </div>
  );
};

HomePage.Layout = HomeLayout;
export default HomePage;
